/* "Any 3 for 999" builder. Data: window.HF_OFFER = { Rings: {collection, items:[{h,t,i}]}, ... }
   Live theme: same markup, but items come from /collections/<handle>/products.json and the
   CTA posts the 3 variants to /cart/add.js with property _offer=3for999 (a discount Function reads it). */
(function () {
  if (window.HFOffer) return;              // script can be included twice (home section + site-wide popup)
  const build = (root) => {
  const DATA = window.HF_OFFER;
  if (!root || !DATA || root.dataset.obReady) return;
  root.dataset.obReady = '1';
  const HTAG = root.dataset.obHeading || 'h1';

  const CATS = Object.keys(DATA);
  const LIMIT = 3, PRICE = '₹999';
  const sized = (u, w) => u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  root.innerHTML =
    '<div class="ob__intro">' +
      '<span class="ob__eyebrow">Anti-tarnish edit</span>' +
      '<' + HTAG + ' class="ob__h">Any 3 pieces.<br><span class="ob__pay">One price, <em>' + PRICE + '</em></span></' + HTAG + '>' +
      '<p class="ob__lede">Every piece ₹499. Pick any 3 rings, kada, bracelets or chains and pay <b>₹999</b>.</p>' +
      '<div class="ob__tray">' +
      '<div class="ob__steps"><span>Your three</span><span class="ob__count" data-ob="count">0 / 3</span></div>' +
      '<div class="ob__slots" data-ob="slots" aria-live="polite"></div>' +
      '<div class="ob__buy"><div class="ob__tag" data-ob="tag"></div><button class="ob__go" data-ob="go" type="button" disabled></button></div>' +
      '<div class="ob__msg" data-ob="msg" role="status"></div>' +
      '</div>' +
      '<ul class="ob__trust"><li>Anti-tarnish finish</li><li>Gift-ready packaging</li></ul>' +
      '<p class="ob__fine">Price drops to ' + PRICE + ' at checkout when 3 eligible pieces are in your bag.</p>' +
    '</div>' +
    '<div class="ob__panel">' +
      '<p class="ob__note"><b>All pieces ₹499.</b> Add 3 or more and each drops to ₹333, so three come to ₹999.</p>' +
      '<div class="ob__tabs" role="tablist" aria-label="Category" data-ob="tabs"></div>' +
      '<div class="ob__grid" role="tabpanel" data-ob="grid"></div>' +
      '<div class="ob__foot"><button class="ob__shuffle" data-ob="shuffle" type="button">Surprise me</button><a class="ob__all" data-ob="all" href="/collections/rings">Browse all</a></div>' +
    '</div>';
  root.classList.add('ob');

  const $ = (k) => root.querySelector('[data-ob="' + k + '"]');
  const slotsEl = $('slots'), tagEl = $('tag'), goEl = $('go'), msgEl = $('msg'), tabsEl = $('tabs'), gridEl = $('grid'), allEl = $('all');
  let cat = CATS[0];
  const picked = [];                       // [{cat, h, t, i}]
  const key = (p) => p.h;
  const has = (h) => picked.some((p) => p.h === h);

  // slots
  slotsEl.innerHTML = [0, 1, 2].map((k) =>
    '<button type="button" class="ob__slot" data-k="' + k + '"><span class="ob__slot-box"><span>' + (k + 1) + '</span><i class="ob__x" aria-hidden="true">×</i></span><span class="ob__slot-name">Empty</span></button>').join('');
  const slotEls = [...slotsEl.querySelectorAll('.ob__slot')];

  // tabs
  tabsEl.innerHTML = CATS.map((c) =>
    '<button type="button" class="ob__tab" role="tab" data-c="' + c + '" aria-selected="' + (c === cat) + '">' + c + ' <small>' + DATA[c].items.length + '</small><span class="n">0</span></button>').join('');
  const tabEls = [...tabsEl.querySelectorAll('.ob__tab')];

  const renderGrid = () => {
    gridEl.innerHTML = DATA[cat].items.map((p, i) =>
      '<button type="button" class="ob__card" style="--i:' + i + '" data-h="' + esc(p.h) + '" aria-pressed="' + has(p.h) + '">' +
        '<figure><img src="' + sized(p.i, 420) + '" alt="" loading="lazy" width="420" height="420"></figure>' +
        '<span class="ob__t">' + esc(p.t) + '</span><i class="ob__add" aria-hidden="true">+</i></button>').join('');
    allEl.textContent = 'Browse all ' + cat.toLowerCase();
    allEl.href = '/collections/' + DATA[cat].collection;
    gridEl.scrollLeft = 0; gridEl.scrollTop = 0;
  };

  const burst = () => {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    for (let i = 0; i < 10; i++) {
      const s = document.createElement('i'); s.className = 'ob__spark';
      const a = (i / 10) * Math.PI * 2, d = 46 + Math.random() * 40;
      s.style.setProperty('--x', Math.cos(a) * d + 'px'); s.style.setProperty('--y', Math.sin(a) * d * .6 + 'px');
      goEl.appendChild(s); setTimeout(() => s.remove(), 900);
    }
  };

  const update = () => {
    const n = picked.length, left = LIMIT - n;
    root.classList.toggle('is-full', n === LIMIT);
    root.classList.toggle('ob--touched', n > 0);
    slotEls.forEach((s, k) => {
      const p = picked[k];
      s.classList.toggle('is-on', !!p);
      const box = s.querySelector('.ob__slot-box'), old = box.querySelector('img'); if (old) old.remove();
      if (p) { const im = document.createElement('img'); im.src = sized(p.i, 240); im.alt = p.t; box.appendChild(im); }
      s.querySelector('.ob__slot-name').textContent = p ? p.t : 'Empty';
      s.setAttribute('aria-label', p ? 'Remove ' + p.t : 'Empty slot ' + (k + 1));
    });
    tagEl.innerHTML = (n === LIMIT ? 'Your 3 pieces' : 'Pick ' + left + ' more') + '<strong>' + PRICE + '</strong>';
    const cEl = $('count'); if (cEl) cEl.textContent = n + ' / ' + LIMIT;
    goEl.disabled = n < LIMIT;
    goEl.style.setProperty('--p', n);
    goEl.innerHTML = '<svg class="ob__go-ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>' + '<span class="ob__go-lbl">' + (n < LIMIT ? 'Pick ' + left + ' more<span class="ob__go-x"> to unlock ' + PRICE + '</span>' : 'Add 3 to bag · ' + PRICE) + '</span><span class="ob__go-count">' + n + '/3</span>';
    if (n === LIMIT && !update.was) { burst(); }
    update.was = n === LIMIT;
    tabEls.forEach((t) => { const c = picked.filter((p) => p.cat === t.dataset.c).length; t.classList.toggle('has', c > 0); t.querySelector('.n').textContent = c; });
    gridEl.querySelectorAll('.ob__card').forEach((b) => { const at = picked.findIndex((p) => p.h === b.dataset.h); b.setAttribute('aria-pressed', at > -1); b.querySelector('.ob__add').textContent = at > -1 ? String(at + 1) : '+'; });
  };

  const flash = (t) => { msgEl.textContent = t; clearTimeout(flash.t); flash.t = setTimeout(() => { msgEl.textContent = ''; }, 2600); };

  gridEl.addEventListener('click', (e) => {
    const b = e.target.closest('.ob__card'); if (!b) return;
    const h = b.dataset.h, ex = picked.findIndex((p) => p.h === h);
    if (ex > -1) { picked.splice(ex, 1); update(); return; }
    if (picked.length >= LIMIT) {
      slotEls.forEach((s) => { s.classList.remove('shake'); void s.offsetWidth; s.classList.add('shake'); });
      flash('Tray is full. Tap a piece above to swap it out.'); return;
    }
    const it = DATA[cat].items.find((p) => p.h === h);
    picked.push({ cat, h: it.h, t: it.t, i: it.i }); update();
  });
  slotEls.forEach((s, k) => s.addEventListener('click', () => { if (picked[k]) { picked.splice(k, 1); update(); } }));
  tabsEl.addEventListener('click', (e) => {
    const t = e.target.closest('.ob__tab'); if (!t) return;
    cat = t.dataset.c; tabEls.forEach((x) => x.setAttribute('aria-selected', x === t)); renderGrid(); update();
  });
  $('shuffle').addEventListener('click', () => {
    picked.length = 0;
    const order = CATS.slice().sort(() => Math.random() - .5);
    for (let k = 0; k < LIMIT; k++) {
      const c = order[k % order.length], list = DATA[c].items.filter((p) => !has(p.h));
      const it = list[Math.floor(Math.random() * list.length)]; picked.push({ cat: c, h: it.h, t: it.t, i: it.i });
    }
    update();
  });

  // add to bag: resolve each handle to an available variant, then one cart/add.js call
  goEl.addEventListener('click', async () => {
    if (picked.length < LIMIT) return;
    goEl.disabled = true; goEl.textContent = 'Adding...';
    try {
      const items = [];
      for (const p of picked) {
        const prod = await (await fetch('/products/' + p.h + '.js')).json();
        const v = prod.variants.find((x) => x.available);
        if (!v) { flash(p.t + ' just sold out. Pick another piece.'); const k = picked.findIndex((q) => q.h === p.h); if (k > -1) picked.splice(k, 1); update(); goEl.disabled = false; return; }
        items.push({ id: v.id, quantity: 1, properties: { _offer: '3for999' } });
      }
      const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items }) });
      if (!r.ok) throw new Error('cart');
      window.location.href = '/cart';
    } catch (err) {
      flash('Could not add to bag. Please try again.');
      goEl.disabled = false; update();
    }
  });

  renderGrid(); update();
  };
  window.HFOffer = { build };
  document.querySelectorAll('[data-offer-builder]:not([data-ob-lazy])').forEach(build);
})();
